import {useAnalyticsEventTracker} from 'nf-ui'
import React, {useState} from 'react'
import {ModalLayout} from '~/components/ModalLayout'
import {EditPrimaryDataLightbox} from './EditPrimaryDataLightbox'
import {OpenPositionFields} from './OpenPositionFields'
import {PrimaryFieldsPanel} from './PrimaryFields'
import {EditProfileData_profile} from './__types__/EditProfileData'

export type PrimaryFields = EditProfileData_profile['primaryFields']

export const PrimaryFieldsTab = ({
    primaryFields,
    profile,
}: {
    primaryFields: PrimaryFields
    profile: EditProfileData_profile
}) => {
    const [primaryDataLightboxOpen, setPrimaryDataLightboxOpen] = useState(false)
    const trackAnalyticsEvent = useAnalyticsEventTracker()

    if (profile.openPosition)
        return <OpenPositionFields fields={primaryFields} openPositionJobLink={profile.openPositionJobLink} />

    return (
        <>
            <PrimaryFieldsPanel
                fields={primaryFields}
                additionalProfile={profile.additional}
                onFieldClick={(field) => {
                    trackAnalyticsEvent('click_disabled_primary_field', {
                        fieldLabel: field.label,
                        fieldType: field.type,
                    })
                    setPrimaryDataLightboxOpen(true)
                }}
            />
            <EditPrimaryDataLightbox
                open={primaryDataLightboxOpen}
                onClose={() => setPrimaryDataLightboxOpen(false)}
                additionalProfile={profile.additional}
            />
            <ModalLayout.Footer />
        </>
    )
}
